/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_DeletedInputs */

const en_admin_permissions_deleted = /** @type {(inputs: Admin_Permissions_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission deleted`)
};

const zh_admin_permissions_deleted = /** @type {(inputs: Admin_Permissions_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`权限已删除`)
};

/**
* | output |
* | --- |
* | "Permission deleted" |
*
* @param {Admin_Permissions_DeletedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_deleted = /** @type {((inputs?: Admin_Permissions_DeletedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_DeletedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_deleted(inputs)
	return zh_admin_permissions_deleted(inputs)
});
export { admin_permissions_deleted as "admin.permissions.deleted" }